export default __webpack_public_path__ + "static/member9-14e544183f05a1e91e25b9e453ed2d9b.jpg";